/* import __COLOCATED_TEMPLATE__ from './duration-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();